<template>
    <div class="group__info margin-top-10">
        <div class="title font-size__medium">
            Luồng xử lý
        </div>
        <transition name="slide">
            <div class="filter flex-row flex__left">
                <div
                        v-for="(item, $index) in breadCrumbData"
                        :key="item.doc.id"
                        :class="[
            item === activeBreadCrumb ? 'active' : '',
            'item',
            'flex-row',
            'flex__center'
          ]"
                        @click="activateBreadCrumb($index)"
                >
                    <span class="index">#{{ $index + 1 }}</span>
                    <span>{{ item.doc.toDeptName || item.doc.publisherName}}</span>
                </div>
            </div>
        </transition>
        <div class="ctn">
            <luong-xy-ly-flow
                    v-if="index !== 0"
                    v-for="(item,index) in breadCrumbData"
                    :key="item.doc.id"
                    :docId="item.doc.id"
                    :subDocId="outgoingDoc.id"
                    v-show="activeBreadCrumb === item"
                    @showSubDocProcessFlow="showSubDocProcessFlow"
            ></luong-xy-ly-flow>
        </div>
    </div>
</template>

<script>
  import incomingDocService from "../../../services/incomingDocService";
  import LuongXyLyFlow from "../../doc-in/components/luong-xu-ly-flow";
  import vbIncomingDocService from "../../../services/vbIncomingDocService";

  export default {
    name: "vbdi-luongxuly",
    props: ["outgoingDoc", "incomingFlowDataSelect"],
    components: {
      LuongXyLyFlow
    },

    data() {
      return {
        rootBreadCrumb: null,
        breadCrumbData: null,
        activeBreadCrumb: null,
        vbIncomingDoc: null
      };
    },

    watch: {
      docId() {
        this.breadCrumbData = null;
        this.initData();
      },
    },

    created() {
      if (this.incomingFlowDataSelect)
        this.initData();
    },

    methods: {
      initData() {
        this.loadDoc().then(
          () => {
            this.rootBreadCrumb = {doc: this.vbIncomingDoc};
            this.breadCrumbData = [(this.activeBreadCrumb = this.rootBreadCrumb)];
            let fakeBreadCrumb = {doc: this.outgoingDoc};
            this.breadCrumbData.unshift(fakeBreadCrumb);
          }
        );
      },

      loadDoc() {
        return incomingDocService
          .findById(this.incomingFlowDataSelect.id, this.outgoingDoc.id)
          .then(response => (this.vbIncomingDoc = response.data));
      },

      showSubDocProcessFlow(event) {
        let process = event.process;
        vbIncomingDocService
          .findByForwardIncomingProcessId(process.id)
          .then(response => {
            if (response.data.id === this.rootBreadCrumb.doc.id) {
              this.activeBreadCrumb = this.rootBreadCrumb;
            } else {
              this.activeBreadCrumb = {
                doc: (this.vbIncomingDoc = response.data)
              };
              this.breadCrumbData.push(this.activeBreadCrumb);
            }
          });
      },

      activateBreadCrumb(index) {
        if (this.activeBreadCrumb !== this.breadCrumbData[index]) {
          let rootIndex = this.breadCrumbData.findIndex(crumb => crumb === this.rootBreadCrumb);
          if (rootIndex > index) {
            this.$emit("closeIncomingDocFlow", {})
          } else {
            this.activeBreadCrumb = this.breadCrumbData[index];
            this.breadCrumbData.splice(index + 1);
          }

        }
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .org-tree-node-children {
        vertical-align: middle !important;
    }

    h1,
    h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .filter {
        margin: 24px 0 12px;
    }

    .filter .item {
        cursor: pointer;
        height: 40px;
        padding: 8px;
        position: relative;
        padding-left: 8px;
        background: var(--color-light);
        font-size: 12px;
        transition: var(--transition-regular);
        margin-right: 4px;
        z-index: 5;
    }

    .filter .item:nth-child(2) {
        z-index: 4;
    }

    .filter .item:nth-child(3) {
        z-index: 3;
    }

    .filter .item:nth-child(4) {
        z-index: 2;
    }

    .filter .item:nth-child(5) {
        z-index: 1;
    }

    .filter .item:nth-child(6) {
        z-index: 0;
    }

    .filter .item:nth-child(7) {
        z-index: -1;
    }

    .filter .item:nth-child(8) {
        z-index: -2;
    }

    .filter .item:nth-child(9) {
        z-index: -3;
    }

    .filter .item:after {
        content: "";
        top: 0;
        position: absolute;
        border-bottom: 20px solid transparent;
        border-top: 20px solid transparent;
        height: 0px;
        width: 0px;
        right: -12px;
        border-left: 12px solid var(--color-light);
        z-index: 10;
        transition: var(--transition-regular);
    }

    .filter .item:not(:first-child):before {
        content: "";
        top: 0;
        position: absolute;
        border-bottom: 20px solid transparent;
        border-top: 20px solid transparent;
        height: 0px;
        width: 0px;
        left: 0;
        border-left: 12px solid #fff;
        z-index: 10;
        transition: var(--transition-regular);
    }

    .filter .item.active {
        background-color: var(--color-blue);
        color: white;
        transition: all 0.25s;
        /* z-index: 10; */
    }

    .filter .item.active:after {
        border-left: 12px solid var(--color-blue);
    }

    .filter .item:not(:first-child) {
        padding-left: 20px;
    }

    .filter .item:first-child {
        border-radius: 4px 0 0 4px;
    }

    .filter .item:last-child {
        /*border-radius: 0 4px 4px 0;*/
        padding-right: 16px;
    }

    .filter .item .index {
        display: none;
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin-right: 4px;
        font-size: 12px;
        color: var(--color-dark);
    }

    .filter .item.active .index {
        background-color: white;
    }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/LuongXuLyV2.vue